import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ban",
  "use": "ban-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ban\"><path d=\"M8.017.067C3.617.067.05 3.633.05 8S3.617 15.933 8 15.933c4.367 0 7.933-3.566 7.933-7.933.017-4.367-3.55-7.933-7.916-7.933M12.983 3.9A6.38 6.38 0 0 1 14.467 8c0 3.567-2.9 6.467-6.467 6.467-1.5 0-2.95-.534-4.133-1.484zm-1.05-1.033-9.083 9.05A6.5 6.5 0 0 1 1.517 8c0-3.567 2.916-6.467 6.483-6.467a6.5 6.5 0 0 1 3.933 1.334\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol